import { render, createRoot } from "@wordpress/element";
import App from "./components/App";
const root = createRoot(document.getElementById("customer_portal"))

// alert('customer_portal is loaded');
// alert('customer_portal is loaded');

function customer_portal() {
    root.render(
        <App />
    )
}

document.addEventListener('DOMContentLoaded', () => {
    const customer = document.getElementById("customer_portal");
    if (customer) {
        customer_portal();
    }
})